import styled from 'styled-components';

export const ButtonLeft = styled.div`
  margin-right: 1rem;
`;
